// extracted by mini-css-extract-plugin
module.exports = {"no-segments-box":"no-segments-box___1uVsK","info-icon":"info-icon___1v_eJ","segment-icon":"segment-icon___2bIq_"};